var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/lodash/_getPrototype.js
// module id = 97
// module chunks = 0